import {
    Card,
    CardHeader,
    CardContent,
    Grid,
    Divider,
    CardActions, Typography, Button
} from "@mui/material";
import StepNavigationButtons from "../components/StepNavigationButtons";
import KeyboardBackspaceOutlinedIcon from "@mui/icons-material/KeyboardBackspaceOutlined";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useForm, FormProvider} from "react-hook-form";
import FinancialDetail from "./components/components-requested-financing/FinancialDetail";
import ReasonDestination from "./components/components-requested-financing/ReasonDestination";
import toast from "react-hot-toast";
import * as yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup";
import {
    SolicitationFinancePreferences,
    SolicitationFinancePreferencesFields,
    SolicitationFinancePreferencesForm
} from "../../../types/financing/financingData";
import {RequiredSchema} from "../../../utils/validations";
import {HttpSolicitationFinancing} from "../../../http/financing/httpFinancing";
import {HttpSolicitationOnboarding} from "../../../http/solicitation/httpSolicitationOnboarding";
import {MiddleStepProps} from "../index";



const StepRequestedFinancing = ({ handleNext, handlePrev, clientSolicitationId }: MiddleStepProps) => {
    const navigate = useNavigate()
    const [financingPreferences, setFinancingPreferences] = useState<SolicitationFinancePreferences>()
    const FinanceSchema = yup.object().shape({
        [SolicitationFinancePreferencesFields.Amount]: RequiredSchema,
    })
    
    const methods = useForm<SolicitationFinancePreferencesForm>({
        resolver: yupResolver(FinanceSchema)
    })
    const loadData = () => {
        HttpSolicitationFinancing.get(clientSolicitationId).then((r) => {
            setFinancingPreferences(r)
        })
    }
    
    useEffect(() => {
        loadData()
    }, [])
    
    
    useEffect(() => {
        if(financingPreferences) {
            methods.reset(financingPreferences)
        }
    }, [financingPreferences])
    
    const onSubmitForm = (data: SolicitationFinancePreferencesForm) => {
        const submitData = {
            ...data
        }
        
        HttpSolicitationFinancing.insert(clientSolicitationId, submitData).then(() => {
            HttpSolicitationOnboarding.getStepResult(clientSolicitationId, 3)
                .then((r) => {
                    if (!r.tieneError) handleNext()
                    else {
                        toast.error(r.descripcionError)
                    }
                })
        }).catch(() => toast.error("Ocurrió un error"))
    }

    return (
        <Card>
            <CardHeader title={
                    <Typography fontSize={21} fontWeight={500}>Financiamiento Solicitado</Typography>
            }
                        action={
                            <Button color='secondary' variant='contained' onClick={() => navigate('/solicitudes')} startIcon={<KeyboardBackspaceOutlinedIcon/>}>
                                Inicio
                            </Button>
                        }
                        subheader={"Los datos con * son obligatorios"}
            />
            <Divider />
            <FormProvider {...methods}>
                <form onSubmit={methods.handleSubmit(onSubmitForm)}>
                    <CardContent>
                            <Grid container spacing={6}>
                                <Grid item xs={12} md={6}>
                                    <FinancialDetail />
                                </Grid>
                                <Grid item xs={12} md={6} mt={4}>
                                    <ReasonDestination preReasonId={financingPreferences?.[SolicitationFinancePreferencesFields.DestinationReasonCode]}
                                                       preElegibility={financingPreferences?.[SolicitationFinancePreferencesFields.EligibilityCode]}
                                    />
                                </Grid>
                            </Grid>
                    </CardContent>
                    <CardActions>
                        <StepNavigationButtons handlePrev={handlePrev} submit/>
                    </CardActions>
                </form>
            </FormProvider>
        </Card>
    )
}


export default StepRequestedFinancing